import { AnyError } from '@microsoft/portal-app/lib/IAnyError';
import { useQuery, UseQueryResult } from 'react-query';
import { IRegionalFormatEntry } from '../models';
import { QueryKey } from '../models/QueryKey';
import { useAuth } from '@iamexperiences/feature-auth';
import { getAvailableLocalesUrl } from '../../redux/modules/graphApis';
import { IODataListValue } from '@microsoft/portal-app/lib/odata-utils';
import { useReportAPITelemetry } from './useReportAPITelemetry';
import { HttpRequestError } from '../../shared/HttpRequestError';
import { settingsManager } from '../../shared/settings';

export const useGetAvailableLocalesQuery = (): UseQueryResult<IRegionalFormatEntry[], AnyError> => {
  const isSupported = !settingsManager.get('isPreferredLanguagesDisabled');

  const { auth } = useAuth();
  const { startTelemetryReport, stopTelemetryReport } = useReportAPITelemetry('getAvailableLocales');
  return useQuery<IRegionalFormatEntry[], AnyError>(
    QueryKey.AVAILABLE_LOCALES,
    async () => {
      const url: string = getAvailableLocalesUrl();
      startTelemetryReport({});
      const clientId = settingsManager.getRequired('clientId');
      const token = await auth.acquireToken({ scopes: [clientId] });
      const response = await fetch(url, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });

      if (!response.ok) {
        const error = new HttpRequestError(response.status, response.statusText);
        stopTelemetryReport('error', error);
        throw error;
      }

      stopTelemetryReport('success', {});
      const data = (await response.json()) as IODataListValue<ReadonlyArray<IRegionalFormatEntry>>;
      return data?.value?.map((item) => item) || [];
    },
    {
      enabled: isSupported,
    },
  );
};
